export const REACT_APP_API_BASE_URL_LOCAL = process.env.REACT_APP_API_BASE_URL_LOCAL;
export const REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;
export const REACT_APP_LIGHTNING_ADDRESS = process.env.REACT_APP_LIGHTNING_ADDRESS;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const REACT_APP_API_BASE_URL_DEV = process.env.REACT_APP_API_BASE_URL_DEV;
export const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
